import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const FormatUnderlinedSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default FormatUnderlinedSVG;
